import React, { useMemo } from 'react';
import { isNil, isNotNil } from 'shared/src/utils';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { isDeliveryTypeIsToday } from '../../../utils/isDeliveryTypeIsToday';
import { isSalesMethodIsPreOrder } from '../../../utils/isSalesMethodIsPreOrder';
import { ColorValues, Flex, Typography } from '@banhala/ui-kit';
import { extractTagInfo } from '../utils/extractHtmlText';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';
import { RemainTimer } from './RemainTimer';
import { useGetDeliveryOrderDeadlineTime } from '../../../hooks/useGetDeliveryOrderDeadlineTime';
import { MarketVacationInfo } from './MarketVacationInfo';
export const StartShippingInfo = () => {
  const { data: goodsBasic } = useGoodsBasic();
  const { data: goodsDetail } = useGoodsDetail();
  const limitTime = useGetDeliveryOrderDeadlineTime(goodsBasic);

  const message = useMemo(
    () =>
      extractTagInfo(
        goodsDetail?.goods.send_expectation_info?.formatted_message ?? null,
      ),
    [goodsDetail?.goods.send_expectation_info?.formatted_message],
  );

  if (isNil(goodsBasic) || isNil(goodsDetail)) {
    return null;
  }

  if (isNotNil(goodsDetail.goods.market.vacation)) {
    return <MarketVacationInfo />;
  }

  // sales_method가 PRE_ORDER가 아니고 delivery-type이 today인 경우
  if (
    !isSalesMethodIsPreOrder(goodsBasic) &&
    isDeliveryTypeIsToday(goodsBasic)
  ) {
    if (isNotNil(limitTime)) {
      return <RemainTimer />;
    }
  }

  // delivery-type이 today나 shak이 아닌 경우, 혹은 sales_method가 PRE_ORDER인 경우
  return (
    <Flex.Row alignItems={'center'} gap={8}>
      <Typography type={'body2'}>
        {message.head}
        <Typography
          type={message.isBold ? 'subtitle2' : 'body2'}
          rawColor={message.color ?? undefined}
        >
          {message.inner}{' '}
        </Typography>
        {message.tail}
      </Typography>
      {goodsDetail?.goods.send_expectation_info?.is_market_provided && (
        <Flex
          padding={{ horizontal: 7, vertical: 5 }}
          backgroundColor={'content_positive'}
          borderRadius={4}
          backgroundColorOpacity={0.2}
        >
          <Typography type={'subtitle6'} rawColor={ColorValues.slate60}>
            판매자 지정
          </Typography>
        </Flex>
      )}
    </Flex.Row>
  );
};
